import type {
  AdClient,
  AdvertisingOverviewView,
  AdvertisingRewardResult,
  AdvertisingSessionView,
  AdPlacement,
} from 'shared';
import { http } from './client';

export const advertisingApi = {
  overview: (client: AdClient): Promise<AdvertisingOverviewView> =>
    http.get(`/advertising/overview?client=${client}`),
  begin: (
    campaignId: string,
    placement: AdPlacement,
    client: AdClient,
  ): Promise<AdvertisingSessionView> =>
    http.post('/advertising/sessions', { campaignId, placement, client }),
  complete: (sessionId: string): Promise<AdvertisingRewardResult> =>
    http.post(`/advertising/sessions/${encodeURIComponent(sessionId)}/complete`),
};
